import { render, staticRenderFns } from "./SfStep.vue?vue&type=template&id=07647059&"
import script from "./SfStep.vue?vue&type=script&lang=js&"
export * from "./SfStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports